import React from "react";
import A from "../../../assets/impact-ratings/A.png";
import B from "../../../assets/impact-ratings/B.png";
import C from "../../../assets/impact-ratings/C.png";
import D from "../../../assets/impact-ratings/D.png";
import E from "../../../assets/impact-ratings/E.png";
import CustomTooltip from "../../../common/components/CustomTooltip";

const LabelChart = ({ value, helpText }) => {
  return (
    <div className="d-flex align-items-top">
      {value && value.toUpperCase() === "A" && (
        <img src={A} width={"100%"} alt="ADME Chart Label A" />
      )}
      {value && value.toUpperCase() === "B" && (
        <img src={B} width={"100%"} alt="ADME Chart Label B" />
      )}
      {value && value.toUpperCase() === "C" && (
        <img src={C} width={"100%"} alt="ADME Chart Label C" />
      )}
      {value && value.toUpperCase() === "D" && (
        <img src={D} width={"100%"} alt="ADME Chart Label D" />
      )}
      {value && value.toUpperCase() === "E" && (
        <img src={E} width={"100%"} alt="ADME Chart Label E" />
      )}
      <div>
        <i
          className="feather icon-info"
          data-tooltip-content={helpText || ""}
          data-tooltip-id="label-help-text"
        />
        <CustomTooltip id="label-help-text" place="left" />
      </div>
    </div>
  );
};

export default LabelChart;
